import httpClient from './httpClient';

const conceptosEstaticosService = {
  // Obtener todos los conceptos configurados como estáticos para una empresa
  obtenerConceptosEstaticos: async (empresaId) => {
    try {
      const response = await httpClient.get(`/conceptos-estaticos/empresa/${empresaId}`);
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al obtener conceptos estáticos:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener conceptos estáticos',
        data: []
      };
    }
  },

  // Obtener todos los conceptos PLAME de ingresos disponibles
  obtenerConceptosIngresosDisponibles: async () => {
    try {
      const response = await httpClient.get('/conceptos-estaticos/conceptos-ingresos');
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al obtener conceptos de ingresos disponibles:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener conceptos de ingresos',
        data: []
      };
    }
  },

  // Configurar qué conceptos están marcados como estáticos para una empresa
  configurarConceptosEstaticos: async (empresaId, conceptosIds) => {
    try {
      const response = await httpClient.post('/conceptos-estaticos/configurar', {
        empresa_id: empresaId,
        conceptos_plame_ids: conceptosIds
      });
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Configuración guardada exitosamente'
      };
    } catch (error) {
      console.error('Error al configurar conceptos estáticos:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al guardar configuración',
        errors: error.response?.data?.errors
      };
    }
  },

  // Agregar un concepto específico como estático
  agregarConceptoEstatico: async (empresaId, conceptoPlameId) => {
    try {
      const response = await httpClient.post('/conceptos-estaticos', {
        id_empresa: empresaId,
        id_concepto_plame: conceptoPlameId
      });
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Concepto agregado exitosamente'
      };
    } catch (error) {
      console.error('Error al agregar concepto estático:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al agregar concepto',
        errors: error.response?.data?.errors
      };
    }
  },

  // Remover un concepto de los estáticos
  removerConceptoEstatico: async (empresaId, conceptoPlameId) => {
    try {
      const response = await httpClient.delete(`/conceptos-estaticos/empresa/${empresaId}/concepto/${conceptoPlameId}`);
      return {
        success: true,
        message: response.data.message || 'Concepto removido exitosamente'
      };
    } catch (error) {
      console.error('Error al remover concepto estático:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al remover concepto'
      };
    }
  },

  // Verificar si un concepto está marcado como estático para una empresa
  verificarConceptoEstatico: async (empresaId, conceptoPlameId) => {
    try {
      const response = await httpClient.get(`/conceptos-estaticos/verificar/${empresaId}/${conceptoPlameId}`);
      return {
        success: true,
        data: response.data.data || response.data,
        esEstatico: response.data.es_estatico || false
      };
    } catch (error) {
      console.error('Error al verificar concepto estático:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al verificar concepto',
        esEstatico: false
      };
    }
  }
};

export default conceptosEstaticosService; 